<template>
  <div class="ryp__desktop">
    <!-- Loading State -->
    <div v-if="loading" class="loading-container">
      <el-loading :loading="loading" text="Loading questionnaire data..."></el-loading>
    </div>

    <!-- Error State -->
    <div v-else-if="error" class="invalid-link-page">
      <div class="invalid-link-content">
        <el-icon class="invalid-link-icon">
          <WarningFilled />
        </el-icon>
        <div class="invalid-link-text">{{ error }}</div>
      </div>
    </div>

    <div v-else>
      <!-- Profile Section -->
    <div v-if="false" class="a-section a-spacing-none ryp__profile__background-color">
      <div class="a-section a-padding-base ryp__profile-container">
        <div class="a-profile ryp__profile__info">
          <div class="a-profile-avatar-wrapper">
            <div class="a-profile-avatar">
              <img src="https://m.media-amazon.com/images/S/amazon-avatars-global/default.png" alt="avatar">
            </div>
          </div>
          <div class="a-profile-content">
            <span class="a-profile-name">{{ profileData.publicName }}</span>
          </div>
        </div>
        <a 
          href="#" 
          class="a-link-normal ryp__profile-edit__link"
          @click.prevent="showEditProfile = true"
        >
          <span><span>Edit public name</span></span>
        </a>
      </div>
    </div>

      <!-- Questionnaire Form (Second Page) -->
      <div v-if="showQuestionnaire" class="a-section in-context-ryp__container">
        <QuestionnaireForm 
          :question-id="questionId" 
          :link-token="linkToken"
          :questionnaire-data="questionnaireData"
          :skip-count="4"
          :first-page-answers="firstPageAnswers"
          :first-page-media-urls="firstPageMediaUrls"
          @back-to-review="handleBackToReview"
        />
      </div>

      <!-- Review Form Section (First Page) -->
      <div v-show="!showQuestionnaire" class="a-section in-context-ryp__container">
      <!-- Product Header -->
      <div class="a-section a-spacing-none in-context-ryp__product-header">
        <img 
          :src="productData.product_image || productData.question_image || productData.imageURL"
          height="64" 
          width="64"
        >
        <div class="a-section in-context-ryp__product-header-question-container">
          <span class="in-context-ryp__product-title a-text-bold">How was the item?</span>
          <span class="in-context-ryp__product-name">{{ productData.description || "暂无描述" }}</span>
        </div>
      </div>

      <!-- Review Form -->
      <form class="in-context-ryp-form-desktop" @submit.prevent="submitReview">
        <div class="a-section in-context-ryp__form_fields_container-desktop">
          
          <!-- Star Rating -->
          <div class="a-section a-spacing-base in-context-ryp__form-field-container">
            <div class="in-context-ryp__form-field--starRating-wrapper">
              <div class="in-context-ryp__form-field--starRating">
                <el-rate
                  v-model="rating"
                  :max="5"
                  text-color="#ff9900"
                />
              </div>
            </div>
          </div>

          <!-- Review Text -->
          <div class="a-section a-spacing-base in-context-ryp__form-field-container">
            <label class="in-context-ryp__field-label" for="reviewText">Write a review </label>
            <div class="a-section a-spacing-none">
              <div class="a-input-text-wrapper in-context-ryp__form-field--reviewText">
                <textarea 
                  id="reviewText"
                  v-model="reviewForm.text"
                  name="reviewText"
                  placeholder="What should other customers know?"
                ></textarea>
              </div>
            </div>
            
            <!-- Ideas to get started (optional) -->
            <div class="a-section ryp__aspects-gallery-info-section" v-if="showAspects">
              <span class="a-text-bold"><span>Ideas to get started</span></span>
              <span class="ryp__aspects-gallery-bottom-sheet__description">
                <span>These are topics other customers want to know more about. Feel free to include them, but they're optional.</span>
              </span>
            </div>
          </div>

          <!-- Media Upload -->
          <div class="a-section a-spacing-base in-context-ryp__form-field-container">
            <label class="in-context-ryp__field-label" for="media">Share a video or photo </label>
            <div class="in-context-ryp__form-field--mediaUploadInput">
              <div class="in-context-ryp__form-field__mediaUploadCTA--no-margin">
                <input 
                  type="file" 
                  id="media" 
                  accept="image/*,video/*"
                  style="display: none;"
                  ref="mediaInput"
                  @change="handleMediaUpload"
                >
                <div 
                  class="in-context-ryp__form-field--mediaUploadInput--custom-wrapper" 
                  tabindex="0"
                  @click="triggerMediaUpload"
                  @keyup.enter="triggerMediaUpload"
                >
                  <div class="in-context-ryp__form-field--mediaUploadInput--custom">
                    <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M14.2835 2.90621H17.1355C18.1899 2.90621 19.0446 3.77168 19.0446 4.83582V10.2425C18.7733 10.0882 18.4594 10 18.125 10C17.0964 10 16.2625 10.8339 16.2625 11.8625V13.7625H14.3625C13.3339 13.7625 12.5 14.5964 12.5 15.625C12.5 16.5051 13.1104 17.2426 13.931 17.4373H1.8957C0.848732 17.4373 0 16.5718 0 15.5077V4.83582C0 3.77013 0.856875 2.90621 1.90193 2.90621H4.91929L7.61784 0H11.4268L14.2835 2.90621ZM9.52235 13.434C11.3689 13.434 12.9579 11.8542 12.9579 9.78934C12.9579 7.72445 11.3689 6.14467 9.52235 6.14467C7.6758 6.14467 6.08677 7.72445 6.08677 9.78934C6.08677 11.8542 7.6758 13.434 9.52235 13.434ZM9.52235 14.684C12.1101 14.684 14.2079 12.4926 14.2079 9.78934C14.2079 7.08609 12.1101 4.89467 9.52235 4.89467C6.93458 4.89467 4.83677 7.08609 4.83677 9.78934C4.83677 12.4926 6.93458 14.684 9.52235 14.684ZM18.125 11.25C18.4633 11.25 18.7375 11.5242 18.7375 11.8625V15.0125H21.8875C22.2258 15.0125 22.5 15.2867 22.5 15.625C22.5 15.9633 22.2258 16.2375 21.8875 16.2375H18.7375V19.3875C18.7375 19.7258 18.4633 20 18.125 20C17.7867 20 17.5125 19.7258 17.5125 19.3875V16.2375H14.3625C14.0242 16.2375 13.75 15.9633 13.75 15.625C13.75 15.2867 14.0242 15.0125 14.3625 15.0125H17.5125V11.8625C17.5125 11.5242 17.7867 11.25 18.125 11.25Z" fill="#565959"/>
                    </svg>
                  </div>
                </div>
                <!-- Uploaded Media Preview -->
                <div v-if="uploadedMedia.length > 0" class="uploaded-media-preview">
                  <div 
                    v-for="(media, index) in uploadedMedia" 
                    :key="index"
                    class="uploaded-media-item"
                  >
                    <img v-if="media.type.startsWith('image')" :src="media.url" alt="uploaded">
                    <video v-else :src="media.url"></video>
                    <span class="remove-media" @click="removeMedia(index)">×</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Review Title -->
          <div class="a-section a-spacing-base in-context-ryp__form-field-container">
            <label class="in-context-ryp__field-label" for="reviewTitle">
              Title your review <span style="font-weight: 400;">(required)</span>
            </label>
            <input 
              type="text" 
              id="reviewTitle"
              v-model="reviewForm.title"
              placeholder="What's most important to know?" 
              name="reviewTitle"
              class="a-input-text in-context-ryp__form-field--reviewTitle"
            >
          </div>
        </div>

        <!-- Submit Button -->
        <div class="a-section in-context-ryp__submit-button-frame-desktop">
          <button
            type="button"
            class="ryp-next-button"
            @click="submitReview"
          >
            Next
          </button>
        </div>
      </form>
    </div>

      <!-- Edit Profile Modal -->
      <el-dialog 
        v-model="showEditProfile" 
        title="Edit your name"
        width="400px"
      >
      <div class="edit-profile-content">
        <p class="edit-profile-subtitle">This is how you'll appear to other customers.</p>
        <el-input 
          v-model="editProfileName" 
          placeholder="Public name"
          maxlength="50"
          show-word-limit
        ></el-input>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="showEditProfile = false">Cancel</el-button>
          <el-button type="primary" @click="saveProfileName">Save</el-button>
        </span>
      </template>
    </el-dialog>

      <!-- Success Message -->
      <el-dialog 
        v-model="showSuccess" 
        title="Review submitted - Thank you!"
        width="500px"
      >
      <div class="success-content">
        <p>We are processing your review. This may take several days, and we will notify you when this is complete.</p>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="showSuccess = false">OK</el-button>
        </span>
      </template>
      </el-dialog>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, computed, watch } from 'vue'
import { getQuestionnaire, getUploadUrl } from '@/api/index'
import { ElMessage } from 'element-plus'
import { WarningFilled } from '@element-plus/icons-vue'
import QuestionnaireForm from './QuestionnaireForm.vue'

defineOptions({
  name: 'ReviewYourPurchases'
})

// Profile Data
const profileData = reactive({
})

// Product Data
const productData = reactive({
})

// Loading and error states
const loading = ref(false)
const error = ref(null)
const invalidLinkMessage = '该问卷链接已失效'
const questionId = ref(null)
const linkToken = ref(null)
const firstPageQuestions = ref([])
const questionnaireData = ref(null)

// Review Form
const reviewForm = reactive({
  rating: 0,
  title: '',
  text: '',
  mediaList: []
})

const rating = ref(0)
const showAspects = ref(false)
const showEditProfile = ref(false)
const showSuccess = ref(false)
const showQuestionnaire = ref(false)
const editProfileName = ref('')
const uploadedMedia = ref([])
const mediaInput = ref(null)

const firstPageAnswers = computed(() => ({
  rating: rating.value,
  text: reviewForm.text,
  title: reviewForm.title
}))

const firstPageMediaUrls = computed(() => (
  uploadedMedia.value.map(media => media.publicUrl || media.url).filter(Boolean)
))

const isRequired = (question) => Number(question?.required) === 1

watch(rating, (value) => {
  reviewForm.rating = value
})

const triggerMediaUpload = () => {
  mediaInput.value.click()
}

const handleMediaUpload = async (event) => {
  const files = event.target.files
  if (!files || files.length === 0) return

  // Find the media type question from first page
  const mediaQuestion = firstPageQuestions.value.find(q => q.question_type === 'media')
  if (!mediaQuestion) {
    ElMessage.error('Media question not found')
    return
  }

  for (let file of files) {
    try {
      // Validate file
      const isImage = file.type.startsWith('image/')
      const isVideo = file.type.startsWith('video/')
      if (!isImage && !isVideo) {
        ElMessage.error('Only image and video files are allowed!')
        continue
      }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        ElMessage.error('File size must be smaller than 10MB!')
        continue
      }

      // Get upload URL
      if (!linkToken.value) {
        ElMessage.error('Link token not found')
        continue
      }
      const uploadUrlResponse = await getUploadUrl(
        linkToken.value,
        mediaQuestion.id,
        file.name,
        file.type,
        file.size
      )
      
      const uploadData = uploadUrlResponse.data?.data || uploadUrlResponse.data
      if (!uploadData || !uploadData.upload_url) {
        ElMessage.error('Failed to get upload URL')
        continue
      }

      // Upload file to OSS using upload_url
      const uploadResponse = await fetch(uploadData.upload_url, {
        method: 'PUT',
        headers: {
          'Content-Type': file.type
        },
        body: file
      })

      if (!uploadResponse.ok) {
        ElMessage.error('Failed to upload file')
        continue
      }

      // Save public_url to uploadedMedia
      const previewUrl = URL.createObjectURL(file) // For preview
      uploadedMedia.value.push({
        file,
        url: previewUrl, // For preview
        publicUrl: uploadData.public_url, // For submission
        type: file.type
      })
    } catch (error) {
      console.error('Error uploading file:', error)
      ElMessage.error('Failed to upload file: ' + (error.message || 'Unknown error'))
    }
  }

  // Reset input
  if (mediaInput.value) {
    mediaInput.value.value = ''
  }
}

const removeMedia = (index) => {
  uploadedMedia.value.splice(index, 1)
}

const saveProfileName = () => {
  if (editProfileName.value.trim()) {
    profileData.publicName = editProfileName.value.trim()
  }
  showEditProfile.value = false
}

const submitReview = async () => {
  if (rating.value < 1 || rating.value > 5) {
    alert('Please select a star rating (1-5)')
    return
  }
  // Validate required fields for first page
  if (firstPageQuestions.value.length) {
    const textQueue = [reviewForm.text, reviewForm.title]
    let textIndex = 0
    for (const question of firstPageQuestions.value) {
      if (!isRequired(question)) continue

      if (question.question_type === 'rating' && (rating.value < 1 || rating.value > 5)) {
        alert('Please select a star rating (1-5)')
        return
      }

      if (question.question_type === 'text') {
        const textValue = textQueue[textIndex] || ''
        textIndex += 1
        if (!textValue.trim()) {
          alert('Text response is required')
          return
        }
      }

      if (question.question_type === 'media' && uploadedMedia.value.length === 0) {
        alert('Please upload a photo or video')
        return
      }
    }
  } else {
    // Fallback validation if questions not loaded
    if (!reviewForm.title.trim()) {
      alert('Title is required')
      return
    }
    if (rating.value < 1 || rating.value > 5) {
      alert('Please select a star rating (1-5)')
      return
    }
  }
  
  // Show questionnaire form (second page)
  showQuestionnaire.value = true
  // Scroll to top
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

const handleBackToReview = () => {
  showQuestionnaire.value = false
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

// Get questionnaire id and link_token from URL query parameters
// URL format: http://localhost:8083/questionnaire?id=1&link_token=20eb16ad3a8644c19770d12fee9b1b7c
const getQuestionnaireParams = () => {
  const urlParams = new URLSearchParams(window.location.search)
  return {
    id: urlParams.get('id'),
    linkToken: urlParams.get('link_token')
  }
}

// Fetch questionnaire data from API
const fetchQuestionnaire = async () => {
  const params = getQuestionnaireParams()
  if (!params.id) {
    console.warn('No questionnaire id found in URL query parameters')
    error.value = invalidLinkMessage
    loading.value = false
    return
  }

  questionId.value = params.id
  linkToken.value = params.linkToken
  loading.value = true
  error.value = null

  try {
    // Use the encapsulated API function
    const response = await getQuestionnaire(params.id)

    // Handle response data
    const payload = response.data?.data || response.data
    if (payload) {
      questionnaireData.value = payload
      const loadedQuestions = Array.isArray(payload.questions) ? payload.questions : []
      if (loadedQuestions.length === 0) {
        error.value = invalidLinkMessage
        return
      }
      const sortedQuestions = loadedQuestions
        .map((question, index) => ({ question, index }))
        .sort((a, b) => {
          const orderA = a.question.sort_order || 0
          const orderB = b.question.sort_order || 0
          if (orderA !== orderB) {
            return orderA - orderB
          }
          return a.index - b.index
        })
        .map(item => item.question)

      firstPageQuestions.value = sortedQuestions.slice(0, 4)

      const firstQuestion = sortedQuestions[0] || null
      if (firstQuestion) {
        Object.assign(productData, firstQuestion)
      }
      if (payload.title || payload.description || payload.product_image || payload.product_description) {
        Object.assign(productData, {
          title: payload.title ?? productData.title,
          description: payload.description ?? productData.description,
          product_image: payload.product_image ?? productData.product_image,
          question_image: payload.product_image ?? productData.question_image,
          imageURL: payload.product_image ?? productData.imageURL,
          product_description: payload.product_description ?? productData.product_description
        })
      }
    } else {
      error.value = invalidLinkMessage
    }
  } catch (err) {
    console.error('Error fetching questionnaire:', err)
    error.value = invalidLinkMessage
  } finally {
    loading.value = false
  }
}

// Fetch questionnaire data when component is mounted
onMounted(() => {
  fetchQuestionnaire()
})
</script>

<style scoped>
/* Main Container */
.ryp__desktop {
  max-width: 100%;
  min-height: 100vh;
  background-color: #fff;
}

/* Profile Section */
.ryp__profile__background-color {
  background-color: #f0f2f2;
  border-bottom: 1px solid #d5d9d9;
}

.ryp__profile-container {
  display: flex;
  align-items: center;
  padding: 14px 20px;
  max-width: 800px;
  margin: 0 auto;
}

.a-profile.ryp__profile__info {
  display: flex;
  align-items: center;
}

.a-profile-avatar-wrapper {
  margin-right: 8px;
}

.a-profile-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
}

.a-profile-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.a-profile-name {
  font-size: 14px;
  font-weight: 700;
  color: #0F1111;
}

.ryp__profile-edit__link {
  margin-left: 10px;
  color: #007185;
  font-size: 13px;
  text-decoration: none;
  cursor: pointer;
}

.ryp__profile-edit__link:hover {
  color: #c7511f;
  text-decoration: underline;
}

/* Review Form Container */
.in-context-ryp__container {
  max-width: 800px;
  margin: 0px auto;
  padding: 0 20px;
}

/* Product Header */
.in-context-ryp__product-header {
  display: flex;
  align-items: flex-start;
  padding-top: 20px;
  margin-bottom: 10px;
}

.in-context-ryp__product-header img {
  width: 64px;
  height: 64px;
  object-fit: contain;
  margin-right: 15px;
  flex-shrink: 0;
}

.in-context-ryp__product-header-question-container {
  flex: 1;
}

.in-context-ryp__product-title {
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: #0F1111;
  margin-bottom: 5px;
}

.in-context-ryp__product-name {
  font-size: 14px;
  color: #565959;
  line-height: 1.4;
  display: block;
}

/* Form */
.in-context-ryp-form-desktop {
  padding-bottom: 30px;
}

.in-context-ryp__form_fields_container-desktop {
  padding: 0;
}

.in-context-ryp__form-field-container {
  margin-bottom: 20px;
}

/* Star Rating */
.in-context-ryp__form-field--starRating-wrapper {
  padding: 0;
}

.in-context-ryp__form-field--starRating {
  display: flex;
  gap: 4px;
}

.in-context-ryp__form-field--starRating :deep(.el-rate__icon) {
  display: inline-block;
  width: 36px;
  height: 34px;
  font-size: 0;
  line-height: 34px;
  background: url("~@/svg/icon-rate.svg") no-repeat center / contain;
}

.in-context-ryp__form-field--starRating :deep(.el-rate__icon svg) {
  display: none;
}

.in-context-ryp__form-field--starRating :deep(.el-rate__item:hover .el-rate__icon),
.in-context-ryp__form-field--starRating :deep(.el-rate__item.is-active .el-rate__icon),
.in-context-ryp__form-field--starRating :deep(.el-rate__icon.hover),
.in-context-ryp__form-field--starRating :deep(.el-rate__icon.is-active) {
  background-image: url("~@/svg/icon-rate-full.svg");
}

.in-context-ryp__form-field--starRating-single {
  cursor: pointer;
  display: inline-block;
  outline: none;
}

.in-context-ryp__form-field--starRating-single img {
  width: 38px;
  height: 36px;
  transition: transform 0.1s ease;
}

.in-context-ryp__form-field--starRating-single:hover img {
  transform: scale(1.1);
}

/* Field Labels */
.in-context-ryp__field-label {
  display: block;
  font-size: 14px;
  font-weight: 700;
  color: #0F1111;
  margin-bottom: 8px;
}

/* Text Area */
.in-context-ryp__form-field--reviewText {
  width: 100%;
}

.in-context-ryp__form-field--reviewText textarea {
  width: 784px;
  min-height: 120px;
  padding: 10px;
  border: 1px solid #888c8c;
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  line-height: 1.5;
}

.in-context-ryp__form-field--reviewText textarea:focus {
  outline: none;
  border-color: #e77600;
  box-shadow: 0 0 3px 2px rgba(228, 121, 17, 0.5);
}

.in-context-ryp__form-field--reviewText textarea::placeholder {
  color: #888c8c;
}

/* Aspects Gallery */
.ryp__aspects-gallery-info-section {
  margin-top: 12px;
  padding: 12px;
  background-color: #f7f7f7;
  border-radius: 4px;
}

.ryp__aspects-gallery-bottom-sheet__description {
  display: block;
  font-size: 13px;
  color: #565959;
  margin-top: 5px;
}

/* Media Upload */
.in-context-ryp__form-field--mediaUploadInput {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.in-context-ryp__form-field__mediaUploadCTA--no-margin {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: flex-start;
}

.in-context-ryp__form-field--mediaUploadInput--custom-wrapper {
  display: inline-flex;
  cursor: pointer;
  outline: none;
}

.in-context-ryp__form-field--mediaUploadInput--custom {
  width: 784px;
  height: 64px;
  background: #F6FAFB;
  border: 1px dashed #BDBEC0;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.2s ease;
}

.in-context-ryp__form-field--mediaUploadInput--custom:hover {
  border-color: #007185;
}

.in-context-ryp__form-field--mediaUploadInput--custom svg {
  width: 23px;
  height: 20px;
}

/* Uploaded Media Preview */
.uploaded-media-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.uploaded-media-item {
  position: relative;
  width: 50px;
  height: 50px;
}

.uploaded-media-item img,
.uploaded-media-item video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.uploaded-media-item .remove-media {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 18px;
  height: 18px;
  background-color: #c7511f;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  cursor: pointer;
  line-height: 1;
}

/* Title Input */
.in-context-ryp__form-field--reviewTitle {
  width: 784px;
  padding: 10px;
  border: 1px solid #888c8c;
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
}

.in-context-ryp__form-field--reviewTitle:focus {
  outline: none;
  border-color: #e77600;
  box-shadow: 0 0 3px 2px rgba(228, 121, 17, 0.5);
}

.in-context-ryp__form-field--reviewTitle::placeholder {
  color: #888c8c;
}

/* Submit Button */
.in-context-ryp__submit-button-frame-desktop {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  box-sizing: content-box;
}

.ryp-next-button {
  width: 110px;
  height: 32px;
  background: #FFD713;
  border-radius: 16px;
  border: none;
  font-family: "PingFang SC-Medium", "PingFang SC", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #191725;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.ryp-next-button:focus {
  outline: none;
}

.ryp-submit-button-desktop {
  display: inline-block;
}

.a-button.a-button-primary {
  background: linear-gradient(to bottom, #f7dfa5, #f0c14b);
  border: 1px solid #a88734;
  border-radius: 3px;
  box-shadow: 0 1px 0 rgba(255,255,255,.4) inset;
}

.a-button.a-button-primary:hover {
  background: linear-gradient(to bottom, #f5d78e, #eeb933);
}

.a-button-inner {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.a-button-input {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.a-button-text {
  padding: 8px 30px;
  font-size: 14px;
  font-weight: 400;
  color: #0F1111;
}

/* Edit Profile Dialog */
.edit-profile-content {
  padding: 10px 0;
}

.edit-profile-subtitle {
  font-size: 14px;
  color: #565959;
  margin-bottom: 15px;
}

/* Success Dialog */
.success-content {
  padding: 10px 0;
}

.success-content p {
  font-size: 14px;
  color: #0F1111;
  line-height: 1.5;
}

/* Loading Container */
.loading-container {
  padding: 40px 20px;
  text-align: center;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Error Container */
.error-container {
  max-width: 800px;
  margin: 20px auto;
  padding: 0 20px;
}

/* Invalid link full page */
.invalid-link-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.invalid-link-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  color: #0F1111;
}

.invalid-link-icon {
  font-size: 48px;
  color: #c7511f;
}

.invalid-link-text {
  font-size: 18px;
  font-weight: 600;
}

/* Responsive */
@media (max-width: 768px) {
  .ryp__profile-container {
    padding: 12px 15px;
  }
  
  .in-context-ryp__container {
    padding: 0 15px;
  }
  
  .in-context-ryp__product-header img {
    width: 48px;
    height: 48px;
  }
  
  .in-context-ryp__form-field--starRating-single img {
    width: 32px;
    height: 30px;
  }
}
</style>

